import { SelectInput } from '@interstate/components/SelectInput';
import { useFlexBuyTermField } from '@makemydeal/dr-dash-components';
import { DealTabs } from '@makemydeal/dr-shared-types';

import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { ScenarioRow } from '../../ScenarioRow';

export const FlexBuyTermRow = () => {
    const { label, selectProps } = useFlexBuyTermField({ tab: DealTabs.SUMMARY });
    const inputId = useScenarioCellId('term');

    return (
        <ScenarioRow rowKey="term" label={label} inputId={inputId}>
            <SelectInput {...selectProps} id={inputId} label={label} displayLabel={false} />
        </ScenarioRow>
    );
};
